import { createFileRoute } from '@tanstack/react-router'
import { useMutation } from '@tanstack/react-query'
import { api } from '../lib/api'
import { useCurrentUser, isSuperAdminRole } from '../lib/auth'
import { useFeatureFlags } from '../lib/features'
import { NotFound } from '../components/NotFound'

export const Route = createFileRoute('/admin/mailpit')({
  component: MailpitPage,
})

function MailpitPage() {
  const { data: me, isLoading: meLoading } = useCurrentUser()
  const flags = useFeatureFlags()

  const open = useMutation({
    mutationFn: api.mailpitSession,
    onSuccess: ({ url }) => {
      window.open(url, '_blank', 'noopener')
    },
  })

  if (meLoading || flags.isLoading) {
    return <PageShell><p className="text-[var(--muted)]">Hleð…</p></PageShell>
  }

  if (!flags.mailpit || !isSuperAdminRole(me)) return <NotFound />

  return (
    <PageShell>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-[var(--fg)]">Mailpit</h1>
        <p className="text-sm text-[var(--muted)] mt-1">
          Póstgildra umhverfisins. Allur póstur sem kerfið sendir endar hér í stað þess að fara út.
        </p>
      </div>
      <div className="rounded-xl border border-[var(--border)] bg-[var(--surface)] shadow-[var(--elev-sm)] p-6">
        <button
          onClick={() => open.mutate()}
          disabled={open.isPending}
          className="px-4 py-2 text-sm font-semibold text-[var(--on-brand)] bg-[var(--brand)] hover:bg-[var(--brand-strong)] disabled:opacity-50 rounded-lg"
        >
          {open.isPending ? 'Opna…' : 'Opna Mailpit'}
        </button>
        {open.error && <p className="mt-3 text-sm text-red-500">{(open.error as Error).message}</p>}
        <p className="mt-3 text-xs text-[var(--muted)]">Aðgangurinn gildir í tvær klukkustundir.</p>
      </div>
    </PageShell>
  )
}

function PageShell({ children }: { children: React.ReactNode }) {
  return <div className="max-w-3xl mx-auto px-6 sm:px-10 py-8 igf-fade">{children}</div>
}
